module.exports = new __parcel__URL__("rare_asteroid.620a8120.png").toString();